import { useState } from "react";
import axios from "axios";

export default function ConnectWhatsApp() {
  const [userId, setUserId] = useState("");
  const [wabaId, setWabaId] = useState("");
  const [phoneNumberId, setPhoneNumberId] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [loading, setLoading] = useState(false);

  const connect = async () => {
    if (!userId || !wabaId || !phoneNumberId || !accessToken) {
      alert("All fields are required!");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post("https://apographic-gonzalo-uneasily.ngrok-free.dev/api/whatsapp/connect", {  // Change to your backend path
        userId,
        wabaId,
        phoneNumberId,
        accessToken
      });
      alert(res.data.message || "Connected successfully!");
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Connection failed");
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 500, margin: "40px auto", padding: 30, border: "1px solid #ccc", borderRadius: 10, boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
      <h2 style={{ textAlign: "center" }}>Connect WhatsApp AI Bot to Your CRM</h2>
      <p style={{ textAlign: "center", color: "#666" }}>Enter your WhatsApp Business details below</p>
      
      <div style={{ marginBottom: 15 }}>
        <label>User ID (Your CRM User/Customer ID)</label>
        <input placeholder="e.g. customer123" value={userId} onChange={e => setUserId(e.target.value)} style={{ width: "100%", padding: 10, marginTop: 5 }} />
      </div>
      
      <div style={{ marginBottom: 15 }}>
        <label>WhatsApp Business Account ID (WABA ID)</label>
        <input placeholder="e.g. 123456789012345" value={wabaId} onChange={e => setWabaId(e.target.value)} style={{ width: "100%", padding: 10, marginTop: 5 }} />
      </div>
      
      <div style={{ marginBottom: 15 }}>
        <label>Phone Number ID</label>
        <input placeholder="e.g. 109876543210987" value={phoneNumberId} onChange={e => setPhoneNumberId(e.target.value)} style={{ width: "100%", padding: 10, marginTop: 5 }} />
      </div>
      
      <div style={{ marginBottom: 20 }}>
        <label>Permanent Access Token</label>
        <input type="password" placeholder="Long token from Meta" value={accessToken} onChange={e => setAccessToken(e.target.value)} style={{ width: "100%", padding: 10, marginTop: 5 }} />
      </div>
      
      <button 
        onClick={connect} 
        disabled={loading}
        style={{ width: "100%", padding: 12, background: "#25D366", color: "white", border: "none", borderRadius: 6, fontSize: 16, cursor: "pointer" }}
      >
        {loading ? "Connecting..." : "Connect WhatsApp Bot"}
      </button>
    </div>
  );
}